module.exports = __webpack_public_path__ + "static/media/Bran Stark.983826e5.jpg";